module.exports = __webpack_public_path__ + "img/three2Green.4f74b656.jpg";